import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'biologia-lista-deadline-lanzamiento';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const storedDeadline = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(storedDeadline) && storedDeadline > Date.now() ? storedDeadline : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const updateTimer = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      });
    };
    updateTimer();
    const interval = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-deep px-2 text-white shadow-sm" data-id="element-17" data-mp="3sgi21k3bx0ss">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-18" data-mp="19fd6zayr6lq">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-19" data-mp="oyhu24xrwvf6">
          <span className="text-brand-yellow" data-id="element-20" data-mp="ty47ofhikdoi">⚡</span> LA OFERTA DE LANZAMIENTO TERMINA EN:
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`Quedan ${timeLeft.hours} horas, ${timeLeft.minutes} minutos y ${timeLeft.seconds} segundos`} data-id="element-21" data-mp="f9q4u4k3kp7y">
          <TimerUnit value={timeLeft.hours} label="HRS" data-id="element-22" data-mp="17xc6v8doflsp" />
          <span className="text-xs font-bold" data-id="element-23" data-mp="17vsrrl3rbgsi">:</span>
          <TimerUnit value={timeLeft.minutes} label="MIN" data-id="element-24" data-mp="1cpdprd5coarp" />
          <span className="text-xs font-bold" data-id="element-25" data-mp="1mkb098w3gqa2">:</span>
          <TimerUnit value={timeLeft.seconds} label="SEG" data-id="element-26" data-mp="1mjstvjfpwvof" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-27" data-mp="1ckttsp90q8d1">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-28" data-mp="18k9wnlog34qw">{label}</span>
    </span>;
}